import React from "react";
// import Blog from "./BlogSection";
import About from "./AboutSection";
import Service from "./ServiceSection";
import Process from "./ProcessSection";
import Testimonial from "./TestimonialSection";
// import Project from "../../components/Project";
import BannerDefault from "../../components/Banner/BannerDefault";

const HomeMain = () => {
  return (
    <React.Fragment>
      <BannerDefault />

      <About />

      <Service />

      <Process />

      {/* <Project /> */}

      {/* <Pricing /> */}

      <Testimonial />

      {/* <Blog /> */}

      {/* <ScrollToTop /> */}
    </React.Fragment>
  );
};

export default HomeMain;
